const _BrandclubStoreConfigUtils = class _BrandclubStoreConfigUtils {
  static getAppStage() {
    const nodeEnv = process.env.NODE_ENV;
    if (nodeEnv === "development") {
      return "localhost";
    }
    const origin = window.location.origin;
    if (origin.includes("beta.brandclub") || origin.includes("-beta.") || origin.includes("beta-")) {
      return "beta";
    }
    if (origin.includes("gamma.brandclub") || origin.includes("-gamma.") || origin.includes("gamma-")) {
      return "gamma";
    }
    return "prod";
  }
  static getWebAppId() {
    return window.location.hostname;
  }
  /**
   * @param parentScriptName - The name of the script that is hosting the common-ui.
   * @returns The origin of the script that is hosting the common-ui.
   */
  static getScriptOrigin(parentScriptName) {
    const currentScript = document.currentScript;
    if (currentScript == null ? void 0 : currentScript.src) {
      return new URL(currentScript.src).hostname;
    }
    if (!parentScriptName) {
      return null;
    }
    const findScript = () => {
      const scripts = Array.from(document.querySelectorAll("script[src]"));
      for (const script2 of scripts) {
        if (script2.src.includes(parentScriptName)) {
          return script2;
        }
      }
      return null;
    };
    const script = findScript();
    if (script == null ? void 0 : script.src) {
      try {
        return new URL(script.src).hostname;
      } catch {
        return null;
      }
    }
    return null;
  }
  static getLocalStorageDomain(appStage = "prod", {
    domainName
  }) {
    if (this.storageDomain) {
      return this.storageDomain;
    }
    const hostname = window.location.hostname.toLowerCase();
    if (hostname.includes("brandclub.com")) {
      this.storageDomain = appStage === "prod" ? "brandclub.com" : `${appStage}.brandclub.com`;
    } else {
      const scriptOrigin = domainName ?? this.getScriptOrigin();
      this.storageDomain = scriptOrigin || (hostname.startsWith("shop.") ? hostname : "shop." + hostname);
    }
    return this.storageDomain;
  }
  static getCookieDomain() {
    if (this.cookieDomain) {
      return this.cookieDomain;
    }
    const hostname = window.location.hostname.toLowerCase();
    const parts = hostname.split(".");
    if (parts.length < 2) {
      this.cookieDomain = hostname;
      return hostname;
    }
    const tld = parts[parts.length - 1];
    let cookieDomain;
    if (tld.length === 2 && parts.length >= 3) {
      cookieDomain = parts.slice(-3).join(".");
    } else {
      cookieDomain = parts.slice(-2).join(".");
    }
    this.cookieDomain = cookieDomain;
    return cookieDomain;
  }
  static getApiHostName() {
    return `${window.location.origin}/api-rewards`;
  }
  static getServerSideSyncHostName() {
    return `${window.location.origin}/api-retailer-sync`;
  }
  static getGoogleMapsApiKey() {
    return "AIzaSyDIvKiFNOD6JC_3ZXMeE4rtPVw49BFanJg";
  }
  static getGoogleMapsMapId() {
    return "6b6881fc70e2cb88";
  }
  static getEdgeCachedApiHostName() {
    return `${window.location.origin}/api-rewards`;
  }
  static getGraphQlUri() {
    const base = this.getApiHostName();
    return `${base}/graphql`;
  }
  static getStripePublishableKey() {
    const appStage = this.getAppStage();
    if (appStage === "localhost" && this.stripeDebugMode) {
      return "pk_test_51SiebcJilhDtJ9iZBhWkI73CyuOtQ883cAFhkILcf1Dh06NOJPAO1LE3su05gFSOgM4PoLcPTFtJyD8bErZbxSYu00BjOvTQAq";
    }
    return "pk_live_51LnQyZJrInA7nkEZJwYqka6fFt6Zz8m1V3l4hC2Rn3N3iLXCWgd8K3oQonZw3SWdpZoZ1UPogaw3kQwt5DyWnVXz00Mr9PFmjh";
  }
  static getServerSideSyncGraphQlUri() {
    const base = this.getServerSideSyncHostName();
    return `${base}/graphql`;
  }
};
_BrandclubStoreConfigUtils.stripeDebugMode = false;
_BrandclubStoreConfigUtils.cookieDomain = "";
_BrandclubStoreConfigUtils.storageDomain = "";
let BrandclubStoreConfigUtils = _BrandclubStoreConfigUtils;
export {
  BrandclubStoreConfigUtils as default
};
//# sourceMappingURL=brandclubStoreConfigUtils.js.map
